import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/main.css'
import transformjetLogo from '../assets/img/about/transformjet.png';
import servicesPicture from '../assets/img/about/about-21-1.jpg';
import businessPicture from '../assets/img/about/about-square-12.jpg';
import person_marcus from '../assets/img/person/person-f-5.webp';
import person_sophia from '../assets/img/person/person-m-8.webp';
import person_daniel from '../assets/img/person/person-f-9.webp';
import person_olivia from '../assets/img/person/person-m-12.webp';
import person_jason from '../assets/img/person/person-m-3.webp';
import person_micheal from '../assets/img/person/person-m-3.webp';
import misc_square from '../assets/img/misc/misc-square-11.webp'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'bootstrap-icons/font/bootstrap-icons.css';
const Landing = () => {

  const [isYearly, setIsYearly] = useState(false);

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };
  const steps = [
    { number: "01", title: "Discovery & Analysis" },
    { number: "02", title: "Strategy Development" },
    { number: "03", title: "Implementation" },
    { number: "04", title: "Monitoring & Optimization" },
    { number: "05", title: "Evaluation & Reporting" }
  ];
  const testimonials = [
    {
      name: 'Michael Anderson',
      role: 'Software Developer',
      img: person_micheal,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce posuere metus vitae arcu imperdiet, id aliquet ante scelerisque.',
    },
    {
      name: 'Sophia Martinez',
      role: 'Marketing Specialist',
      img: person_sophia,
      text: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum.',
    },
    {
      name: 'David Wilson',
      role: 'Graphic Designer',
      img: person_daniel,
      text: 'Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui.',
    },
    {
      name: 'Emily Johnson',
      role: 'UX Designer',
      img: person_sophia,
      text: 'Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae.',
    },
    {
      name: 'Olivia Thompson',
      role: 'Entrepreneur',
      img: person_olivia,
      text: 'Praesent nonummy mi in odio. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.',
    },
    {
      name: 'James Taylor',
      role: 'Financial Analyst',
      img: person_marcus,
      text: 'Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis.',
    },
  ];
  const stepDescription =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.";
  const servicesData = [
    {
      title: "AI Transformation",
      slug: "ai-transformation",
      icon: "bi-bar-chart-line",
      description: "Empower your business with intelligent automation, data-driven decisions, and adaptive workflows.AI streamlines operations, enhances customer experiences, and accelerates innovation.From task execution to strategic foresight, AI becomes a core driver of growth.",
      features: ["Strategic Automation", "Data-Driven Intelligence", "Scalable Integration"],
    },
    {
      title: "IT Modernization",
      slug: "it-modernization",
      icon: "bi-briefcase",
      description: "Modernizes legacy systems with cloud-native, scalable, and secure architectures.It enables faster delivery through DevOps automation and API-driven integrations.Organizations gain agility, better performance, and future-ready infrastructure.",
      features: ["Cloud-Native Migration", "DevOps & Automation", "API-First Architecture"],
    },
    {
      title: "Business Automation",
      slug: "business-automation",
      icon: "bi-cash-coin",
      description: "TransformJet automates repetitive tasks, approvals, and workflows across departments.It connects systems like CRM, ERP, and HRMS for seamless data flow and process visibility.Businesses save time, reduce errors, and improve operational efficiency at scale.",
      features: ["Workflow Orchestration", "Task & Approval Automation", "System Integration"],
    },
    // {
    //   title: "Human Resources",
    //   icon: "bi-people",
    //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    //   features: ["Talent Acquisition", "Performance Management", "Leadership Development"],
    // },
    // {
    //   title: "Technology Transformation",
    //   icon: "bi-laptop",
    //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    //   features: ["IT Strategy", "System Implementation", "Cybersecurity"],
    // },
    // {
    //   title: "Marketing Strategy",
    //   icon: "bi-megaphone",
    //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    //   features: ["Brand Development", "Digital Marketing", "Market Research"],
    // },
  ];
  const teamMembers = [
    {
      name: 'Marcus Wilson',
      role: 'Chief Technology Officer',
      img: person_marcus,
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis.',
    },
    {
      name: 'Sophia Reynolds',
      role: 'Product Designer',
      img: person_sophia,
      desc: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    },
    {
      name: 'Daniel Chen',
      role: 'Marketing Specialist',
      img: person_daniel,
      desc: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
      name: 'Olivia Thompson',
      role: 'Lead Developer',
      img: person_olivia,
      desc: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.',
    },
    {
      name: 'Jason Parker',
      role: 'UI/UX Designer',
      img: person_jason,
      desc: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni.',
    },
  ];
  return (
    <>
      <header id="header" className="header d-flex align-items-center fixed-top">
        <div className="container position-relative d-flex align-items-center justify-content-between">

          <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">

            <img
              src={transformjetLogo}
              alt="TransformJet"
              height="50"
              width="100"
            />
          </a>

          <nav id="navmenu" className="navmenu">
            <ul>
              <li><a href="#hero" className="active">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#solution">Solution</a></li>
              <li><a href="#why-choose-us">Why Choose Us</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#team">Team</a></li>
              <li className="dropdown">
                <a href="#"><span>Features</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                  <li><a href="#">AI Agent</a></li>

                  <li><a href="#">Workflow</a></li>
                  <li><a href="#">Integrations</a></li>

                </ul>
              </li>
              <li><a href="#contact">Contact</a></li>
            </ul>
            <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
          </nav>
          <Link to="/login"><a className="btn-getstarted" >Login</a></Link>

        </div>
      </header>
      <main className="main">
        {/* Hero Section */}
        <section id="hero" className="hero section dark-background">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
                  <h2>TransformJet</h2>
                  <h4>AI Transformation | IT Modernization | Business Automation</h4>
                  <br></br>
                  <p>
                    TransformJet is a powerful platform that helps organizations drive AI transformation, accelerate IT modernization, and implement intelligent automation. Designed for businesses ready to scale, TransformJet empowers you to optimize operations, reduce costs, and make data-driven decisions with confidence.
                  </p>
                  <div className="hero-btns">
                    <a href="#consultation" className="btn btn-primary">Get a Free Consultation</a>
                    <a href="#services" className="btn btn-outline">Our Services</a>
                  </div>
                  <div className="hero-stats d-flex mt-4 gap-4 flex-wrap">
                    <div className="stat-item">
                      <h3><span className="purecounter" data-purecounter-start="0" data-purecounter-end="15" data-purecounter-duration="1">15</span>+</h3>
                      <p>Years Experience</p>
                    </div>
                    <div className="stat-item">
                      <h3><span className="purecounter" data-purecounter-start="0" data-purecounter-end="500" data-purecounter-duration="1">500</span>+</h3>
                      <p>Clients Worldwide</p>
                    </div>
                    <div className="stat-item">
                      <h3><span className="purecounter" data-purecounter-start="0" data-purecounter-end="98" data-purecounter-duration="1">98</span>%</h3>
                      <p>Success Rate</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="300">
                <div className="hero-image">
                  <img src={servicesPicture} alt="Transformation Services" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="200">
                <div className="about-image position-relative">
                  <img
                    src={businessPicture}
                    alt="About Our Transformation Firm"
                    className="img-fluid main-image"
                  />
                  <div className="experience-badge position-absolute top-0 start-0 bg-primary text-white p-2 rounded">
                    <span className="years h4">15+</span>
                    <br />
                    <span className="text small">Years of Experience</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                <div className="about-content">
                  <h2>We Help Businesses Reach Their Full Potential</h2>
                  <p className="lead">
                    TransformJet empowers organizations through AI transformation, IT modernization, and intelligent automation.
                  </p>
                  <p>
                    We simplify complexity, reduce operational friction, and enable scalable growth through future-ready solutions.
                  </p>

                  <div className="row features-row">
                    {[
                      {
                        icon: 'bi-graph-up-arrow',
                        title: 'Business Growth',
                        description: 'We accelerate digital maturity, helping businesses scale faster and operate more efficiently.',
                      },
                      {
                        icon: 'bi-lightbulb',
                        title: 'Innovative Solutions',
                        description: 'From AI-powered automation to cloud-native modernization, we deliver forward-thinking technology.',
                      },
                      {
                        icon: 'bi-people',
                        title: 'Expert Team',
                        description: 'Our multidisciplinary team brings deep technical knowledge and industry experience to every engagement.',
                      },
                      {
                        icon: 'bi-trophy',
                        title: 'Proven Results',
                        description: 'We deliver measurable outcomes—boosting productivity, reducing costs, and enabling smarter decisions.',
                      },
                    ].map((item, index) => (
                      <div className="col-md-6 mb-3" key={index}>
                        <div className="feature-item d-flex align-items-start gap-3 p-3 rounded shadow-sm bg-light">
                          <div className="icon">
                            <i className={`bi ${item.icon} fs-4`} aria-hidden="true"></i>
                          </div>
                          <div>
                            <h4 className="mb-1">{item.title}</h4>
                            <p className="small">{item.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>


                  <div className="cta-button mt-3">
                    <a href="#about" className="btn btn-primary">
                      Learn More About Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="work-process" className="work-process section">
          {/* Section Title */}
          <div className="container section-title" data-aos="fade-up">
            <h2>Our Transformation Process</h2>
            <div>
              <span>Check Our </span>
              <span className="description-title">Our Transformation Process</span>
            </div>
          </div>

          {/* Work Process Content */}
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row">
              {/* Left Column - Description */}
              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                <div className="steps-content">
                  <h2>Our Proven Transformation Process</h2>
                  <p className="lead">{stepDescription}</p>
                  <p>
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                    doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                    veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                  </p>
                  <div className="steps-cta mt-3 d-flex gap-3">
                    <a href="#contact" className="btn btn-primary">
                      Start Your Project
                    </a>
                    <a href="#about" className="btn btn-outline">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>

              {/* Right Column - Steps */}
              <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="300">
                <div className="steps-list">
                  {steps.map((step, index) => (
                    <div className="step-item mb-4 d-flex" key={index}>
                      <div className="step-number  fw-bold d-flex align-items-center justify-content-center me-3" style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        fontSize: "18px"
                      }}>
                        {step.number}
                      </div>
                      <div className="step-content">
                        <h3 className="mb-1">{step.title}</h3>
                        <p className="mb-0">{stepDescription}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="solution" className="solution section">
          {/* Section Title */}
          <div className="container section-title" data-aos="fade-up">
            <h2>Services</h2>
            <div>
              <span>Check Our </span>
              <span className="description-title">Solutions</span>
            </div>
          </div>

          {/* Service Cards */}
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4">
              {servicesData.map((service, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={200 + index * 100}
                >
                  <div className="service-card p-4 border rounded h-100 shadow-sm">
                    <div className="icon-box mb-3">
                      <i className={`bi ${service.icon} fs-2 `}></i>
                    </div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="service-features list-unstyled mt-3">
                      {service.features.map((feature, i) => (
                        <li key={i}>
                          <i className="bi bi-check-circle text-success me-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <Link to={`/service-detail/${service.slug}`} className="read-more d-inline-block mt-3 text-decoration-none">
                      Learn More <i className="bi bi-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Call to Action */}
            <div className="text-center mt-5" data-aos="fade-up" data-aos-delay="800">
              <a href="#contact" className="btn btn-primary">
                Request a Consultation
              </a>
            </div>
          </div>
        </section>
        <section id="consultation" className="consultation section light-background">
          {/* Section Title */}
          <div className="container section-title" data-aos="fade-up">
            <h2>Consultation Form</h2>
            <div>
              <span>Schedule a </span>
              <span className="description-title">Consultation Form</span>
            </div>
          </div>

          {/* Content */}
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="cta-wrapper">
              <div className="row align-items-center">
                {/* Left Side: Stats & Description */}
                <div className="col-lg-7" data-aos="fade-up" data-aos-delay="200">
                  <div className="cta-content">
                    <h2>Ready to Transform Your Business?</h2>
                    <p>
                      TransformJet helps you break through operational limits with AI-driven solutions, modern infrastructure, and intelligent automation.
                    </p>
                    <p>
                      Our platform is designed to simplify transformation, boost efficiency, and drive measurable business outcomes.
                    </p>
                    <p>
                      Let us help you unlock your next level of growth—smarter, faster, and future-ready.
                      Get started today and lead the change in your industry.

                    </p>
                    <div className="cta-stats d-flex flex-wrap gap-4 mt-4">
                      <div className="stat-item text-center">
                        <span className="number h3">500+</span>
                        <br />
                        <span className="text small">Projects Completed</span>
                      </div>
                      <div className="stat-item text-center">
                        <span className="number h3">98%</span>
                        <br />
                        <span className="text small">Client Satisfaction</span>
                      </div>
                      <div className="stat-item text-center">
                        <span className="number h3">15+</span>
                        <br />
                        <span className="text small">Years Experience</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side: Form */}
                <div className="col-lg-5" data-aos="fade-up" data-aos-delay="300">
                  <div className="cta-form bg-white p-4 rounded shadow-sm">
                    <h3>Schedule a Free Consultation</h3>
                    <p>Fill out the form below and our team will contact you within 24 hours.</p>
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="form-group mb-3">
                        <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                      </div>
                      <div className="form-group mb-3">
                        <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                      </div>
                      <div className="form-group mb-3">
                        <input type="text" name="phone" className="form-control" placeholder="Your Phone" />
                      </div>
                      <div className="form-group mb-4">
                        <select name="service" className="form-control" required>
                          <option value="" disabled selected>
                            Select Service
                          </option>
                          <option>Strategic Planning</option>
                          <option>Business Transformation</option>
                          <option>Financial Advisory</option>
                          <option>Human Resources</option>
                          <option>Technology Transformation</option>
                        </select>
                      </div>

                      {/* Feedback placeholders */}
                      <div className="my-3">
                        <div className="loading d-none">Loading</div>
                        <div className="error-message text-danger d-none"></div>
                        <div className="sent-message text-success d-none">Your message has been sent. Thank you!</div>
                      </div>

                      <div className="text-center">
                        <button type="submit" className="btn btn-primary">
                          Get Started
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="why-choose-us" className="why-choose-us section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Why Choose Us</h2>
            <div><span>Why Choose</span> <span className="description-title">Our Services</span></div>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                <div className="features-content">
                  <h2>Why Choose Our Transformation Services</h2>
                  <p className="lead">TransformJet is your trusted partner in AI transformation, IT modernization, and automation.
                    We simplify complexity and deliver tailored, scalable solutions for forward-thinking businesses.
                  </p>
                  <p>Experience faster growth, smarter operations, and measurable impact—powered by technology.</p>

                  <div className="features-list">
                    <div className="feature-item">
                      <div className="feature-icon"><i className="bi bi-award"></i></div>
                      <div className="feature-text">
                        <h4>Industry Expertise</h4>
                        <p>We understand the unique challenges across industries and build solutions that fit your domain perfectly.</p>
                      </div>
                    </div>

                    <div className="feature-item">
                      <div className="feature-icon"><i className="bi bi-graph-up"></i></div>
                      <div className="feature-text">
                        <h4>Data-Driven Approach</h4>
                        <p>Every decision is backed by analytics, ensuring precision, insight, and continuous improvement.</p>
                      </div>
                    </div>

                    <div className="feature-item">
                      <div className="feature-icon"><i className="bi bi-clock-history"></i></div>
                      <div className="feature-text">
                        <h4>Timely Delivery</h4>
                        <p>We follow agile execution models to deliver milestones on time—without compromising quality.</p>
                      </div>
                    </div>

                    <div className="feature-item">
                      <div className="feature-icon"><i className="bi bi-shield-check"></i></div>
                      <div className="feature-text">
                        <h4>Guaranteed Results</h4>
                        <p>Our outcomes are measurable, with proven ROI in efficiency, scalability, and digital transformation.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                <div className="features-image">
                  <div className="stats-card">
                    <div className="stat-item"><h3>95%</h3><p>Client Satisfaction</p></div>
                    <div className="stat-item"><h3>250+</h3><p>Projects Completed</p></div>
                    <div className="stat-item"><h3>30+</h3><p>Industry Awards</p></div>
                    <div className="stat-item"><h3>20+</h3><p>Countries Served</p></div>
                  </div>
                  <img src={misc_square} alt="" className="img-fluid main-image" />
                  <div className="experience-badge">
                    <div className="badge-content">
                      <span className="number">15+</span>
                      <span className="text">Years of Excellence</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="team" className="team section">
          {/* Section Title */}
          <div className="container section-title" data-aos="fade-up">
            <h2>Team</h2>
            <div>
              <span>Check Our </span>
              <span className="description-title">Expert Team</span>
            </div>
          </div>

          {/* Swiper Slider */}
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              speed={800}
              autoplay={{ delay: 5000 }}
              spaceBetween={30}
              pagination={{ clickable: true }}
              navigation={true}
              breakpoints={{
                576: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
              }}
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={index}>
                  <div className="team-card">
                    <div className="team-image position-relative">
                      <img src={member.img} alt={member.name} className="img-fluid rounded" loading="lazy" />
                      <div className="team-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                        <div className="social-links d-flex gap-3">
                          <a href="#"><i className="bi bi-twitter-x"></i></a>
                          <a href="#"><i className="bi bi-facebook"></i></a>
                          <a href="#"><i className="bi bi-instagram"></i></a>
                          <a href="#"><i className="bi bi-linkedin"></i></a>
                        </div>
                      </div>
                    </div>
                    <div className="team-content text-center mt-3">
                      <h3 className="mb-1">{member.name}</h3>
                      <span className="d-block text-muted mb-2">{member.role}</span>
                      <p className="small">{member.desc}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
        <section id="testimonials" className="testimonials section light-background">
          <div className="container section-title" data-aos="fade-up">
            <h2>Testimonials</h2>
            <div>
              <span>Check Our </span>
              <span className="description-title">Testimonials</span>
            </div>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row g-4">
              {testimonials.map((item, index) => (
                <div className="col-lg-6" key={index} data-aos="fade-up" data-aos-delay={100 * (index + 1)}>
                  <div className="testimonial-item">
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="bi bi-star-fill"></i>
                      ))}
                    </div>
                    <p>{item.text}</p>
                    <div className="testimonial-footer">
                      <div className="testimonial-author">
                        <img src={item.img} alt="Author" className="img-fluid rounded-circle" loading="lazy" />
                        <div>
                          <h5>{item.name}</h5>
                          <span>{item.role}</span>
                        </div>
                      </div>
                      <div className="quote-icon">
                        <i className="bi bi-quote"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section id="pricing" className="pricing section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Our Pricing Plans</h2>
            <div><span>Check Our</span> <span className="description-title">Pricing Plans</span></div>
          </div>

          <div className="container pricing-toggle-container" data-aos="fade-up" data-aos-delay="100">
            <div className="d-flex align-items-center justify-content-center text-center">
              <div className="pricing-toggle">
                <span className={`monthly ${!isYearly ? "active" : ""}`}>Monthly</span>
                <label className="switch">
                  <input type="checkbox" checked={isYearly} onChange={togglePricing} />
                  <span className="slider"></span>
                </label>
                <span className={`yearly ${isYearly ? "active" : ""}`}>Yearly</span>
                <div className="discount-badge">Save 20%</div>
              </div>
            </div>

            <div className="row">
              {[
                {
                  title: "Basic Plan",
                  monthly: "$1,499",
                  yearly: "$14,390",
                  desc: "Perfect for small businesses",
                  features: [
                    "Business Analysis", "Strategic Planning", "10 Transformation Hours", "Monthly Report",
                    'Market Research', 'Implementation Support', 'Dedicated Consultant'
                  ],
                  featured: false
                },
                {
                  title: "Professional Plan",
                  monthly: "$2,999",
                  yearly: "$28,790",
                  desc: "Ideal for growing companies",
                  features: [
                    "Business Analysis", "Strategic Planning", "25 Transformation Hours", "Weekly Reports",
                    "Market Research", "Implementation Support", 'Dedicated Consultant'
                  ],
                  featured: true
                },
                {
                  title: "Enterprise Plan",
                  monthly: "$4,999",
                  yearly: "$47,990",
                  desc: "For established enterprises",
                  features: [
                    "Business Analysis", "Strategic Planning", "50 Transformation Hours", "Weekly Reports",
                    "Market Research", "Implementation Support", "Dedicated Consultant"
                  ],
                  featured: false
                }
              ].map((plan, index) => (
                <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={`${(index + 2) * 100}`} key={index}>
                  <div className={`pricing-item ${plan.featured ? "featured" : ""}`}>
                    {plan.featured && <div className="pricing-badge">Popular</div>}
                    <div className="pricing-header">
                      <h3>{plan.title}</h3>
                      <div className="price-monthly" style={{ display: isYearly ? "none" : "block" }}>{plan.monthly}<span>/mo</span></div>
                      <div className="price-yearly" style={{ display: isYearly ? "block" : "none" }}>{plan.yearly}<span>/year</span></div>
                      <p>{plan.desc}</p>
                    </div>
                    <div className="pricing-features">
                      <ul>
                        {plan.features.map((f, i) => (
                          <li key={i}>
                            <i className={`bi ${f ? "bi-check-circle" : "bi-x-circle"}`}></i> {f || ""}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="pricing-footer">
                      <a href="#contact" className={`btn ${plan.featured ? "btn-primary" : "btn-outline"}`}>Get Started</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="pricing-note text-center mt-5" data-aos="fade-up" data-aos-delay="600">
              <p>Need a custom solution? <a href="#contact">Contact us</a> for a personalized quote.</p>
            </div>
          </div>
        </section>

        <section id="faq" class="faq section">


          <div class="container section-title" data-aos="fade-up">
            <h2>Frequently Asked Questions</h2>
            <div><span>Frequently Asked</span> <span class="description-title">Questions</span></div>
          </div>

          <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row gy-4 justify-content-between">
              <div class="col-lg-8">

                <div class="faq-list">
                  <div class="faq-item faq-active" data-aos="fade-up" data-aos-delay="100">
                    <h3>What is TransformJet?</h3>
                    <div class="faq-content">
                      <p>
                        TransformJet is a comprehensive platform that enables AI transformation, IT modernization, and business automation for organizations across industries.
                      </p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="200">
                    <h3>Who can benefit from using TransformJet?</h3>
                    <div class="faq-content">
                      <p>
                        Businesses of all sizes—from startups to enterprises—seeking to optimize operations, modernize infrastructure, and implement smart automation.
                      </p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="300">
                    <h3>Can TransformJet integrate with our existing tools like CRM, ERP, or HRMS?</h3>
                    <div class="faq-content">
                      <p>
                        Yes, TransformJet supports seamless integration through APIs, allowing it to work with most enterprise systems and tools.
                      </p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="400">
                    <h3>Is the platform customizable to suit our specific business needs?</h3>
                    <div class="faq-content">
                      <p>
                        Absolutely. TransformJet is modular and fully customizable to align with your unique workflows, industry standards, and organizational goals.                      </p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="500">
                    <h3>How long does implementation typically take?</h3>
                    <div class="faq-content">
                      <p>
                        Depending on your scope and complexity, implementations can range from a few weeks for basic setups to a few months for enterprise-wide rollouts.
                      </p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="400">
                    <h3>What kind of support do you offer post-deployment?</h3>
                    <div class="faq-content">
                      <p>
                        We provide end-to-end support including training, documentation, performance monitoring, and dedicated success teams.</p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                  <div class="faq-item" data-aos="fade-up" data-aos-delay="400">
                    <h3>Is TransformJet secure and compliant with industry standards?</h3>
                    <div class="faq-content">
                      <p>
                        Yes, we follow industry best practices and compliance standards for data security, privacy, and system reliability.</p>
                    </div>
                    <i class="bi bi-plus faq-toggle"></i>
                  </div>

                </div>

              </div>

              <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div class="faq-card">
                  <i class="bi bi-chat-dots-fill"></i>
                  <h3>Can't find answer to your question?</h3>
                  <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Curabitur aliquet quam id dui posuere blandit. Nulla quis lorem ut libero malesuada feugiat.</p>
                  <a href="#contact" class="btn btn-primary">Contact Us</a>
                </div>
              </div>
            </div>

          </div>

        </section>
        <section id="contact" className="contact section">
          <div className="container section-title">
            <h2>Contact</h2>
            <div><span>Contact</span> <span className="description-title">Us</span></div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="contact-info">
                  <div className="contact-card">
                    <h3>Contact Information</h3>
                    <p>Feel free to reach out with any questions about the book, speaking engagements, or media inquiries.</p>
                    <div className="contact-details">
                      <div className="contact-item">
                        <i className="bi bi-envelope"></i>
                        <div>
                          <h4>Email:</h4>
                          <p>author@example.com</p>
                        </div>
                      </div>
                      <div className="contact-item">
                        <i className="bi bi-telephone"></i>
                        <div>
                          <h4>Phone:</h4>
                          <p>+1 (555) 123-4567</p>
                        </div>
                      </div>
                      <div className="contact-item">
                        <i className="bi bi-geo-alt"></i>
                        <div>
                          <h4>Address:</h4>
                          <p>123 Book Street, Literary Lane</p>
                          <p>Wordsmith City, NY 10001</p>
                        </div>
                      </div>
                    </div>
                    <div className="social-links">
                      <a href="#"><i className="bi bi-twitter"></i></a>
                      <a href="#"><i className="bi bi-facebook"></i></a>
                      <a href="#"><i className="bi bi-instagram"></i></a>
                      <a href="#"><i className="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="contact-form-wrapper">
                  <form action="forms/contact.php" method="post" className="php-email-form">
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label htmlFor="name">Your Name</label>
                        <input type="text" name="name" className="form-control" id="name" placeholder="John Doe" required />
                      </div>
                      <div className="col-md-6 form-group mt-3 mt-md-0">
                        <label htmlFor="email">Your Email</label>
                        <input type="email" className="form-control" name="email" id="email" placeholder="john@example.com" required />
                      </div>
                    </div>
                    <div className="form-group mt-3">
                      <label htmlFor="subject">Subject</label>
                      <input type="text" className="form-control" name="subject" id="subject" placeholder="I loved your book!" required />
                    </div>
                    <div className="form-group mt-3">
                      <label htmlFor="message">Message</label>
                      <textarea className="form-control" name="message" rows="7" placeholder="Your message here..." required></textarea>
                    </div>

                    <div className="my-3">
                      <div className="loading">Loading</div>
                      <div className="error-message"></div>
                      <div className="sent-message">Your message has been sent. Thank you!</div>
                    </div>

                    <div className="text-center">
                      <button type="submit">Send Message</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer id="footer" className="footer light-background">
          <div className="container">
            <div className="row gy-3">
              <div className="col-lg-3 col-md-6 d-flex">
                <i className="bi bi-geo-alt icon"></i>
                <div className="address">
                  <h4>Address</h4>
                  <p>A108 Adam Street</p>
                  <p>New York, NY 535022</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex">
                <i className="bi bi-telephone icon"></i>
                <div>
                  <h4>Contact</h4>
                  <p>
                    <strong>Phone:</strong> <span>+1 5589 55488 55</span><br />
                    <strong>Email:</strong> <span>info@example.com</span><br />
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex">
                <i className="bi bi-clock icon"></i>
                <div>
                  <h4>Opening Hours</h4>
                  <p>
                    <strong>Mon-Sat:</strong> <span>11AM - 23PM</span><br />
                    <strong>Sunday:</strong> <span>Closed</span>
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <h4>Follow Us</h4>
                <div className="social-links d-flex">
                  <a href="#" className="twitter"><i className="bi bi-twitter-x"></i></a>
                  <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
                  <a href="#" className="instagram"><i className="bi bi-instagram"></i></a>
                  <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div className="container copyright text-center mt-4">
            <p>© <span>Copyright</span> <strong className="px-1 sitename">Transformation.</strong> <span>All Rights Reserved</span></p>
            <div className="credits">
              Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
};

export default Landing;